// extracted by mini-css-extract-plugin
export default {"wrapper":"PunchupLoadMore_wrapper__iS1aq","button":"PunchupLoadMore_button__j0+zT punchupButton punchupButtonOutline"};